module.exports = __webpack_public_path__ + "img/triangle-70.48c17853.gif";